import { showError } from 'redux/modules/notification';
import { goToCreate } from 'redux/modules/router';
import { ThunkAction } from 'redux/types';
import { isApplicationError } from 'utils/ApplicationError';
import { FatalError } from 'utils/FatalError';

const ERROR_ID = 'template-wizard-error';

export const templateWizardError = (
  error: Error,
  bail: boolean = false,
): ThunkAction<void> => dispatch => {
  if (error instanceof FatalError) {
    dispatch(
      showError({
        message: 'There was an error creating your project',
        code: 'ER007',
        dismissAfterSec: 5,
        id: ERROR_ID,
      }),
    );
    dispatch(goToCreate());
  } else {
    dispatch(
      showError({
        message: error.message,
        code: isApplicationError(error) ? error.code : undefined,
        dismissAfterSec: 5,
        id: ERROR_ID,
      }),
    );
  }

  if (bail) {
    dispatch(goToCreate());
  }
};
